import React from 'react'
import Chart from 'react-apexcharts'

const ReactApexchart = ({ options, series, type, ...rest }) => {
  return <Chart options={options} series={series} type={type} {...rest} />
}

export default ReactApexchart
